import { BufferAttribute, Mesh, ShaderMaterial, SphereGeometry } from '@anov/3d-core'
import skyShader from '../../shaders/sky'

class OutlineMesh extends Mesh {
  mesh!: Mesh
  uniforms: any = {
    skyTime: { value: 12.0 },
    skyOpacity: { value: 0.8 },
  }

  constructor() {
    super()

    this.geometry = new SphereGeometry(1, 32, 32, 0, Math.PI * 2, 0, Math.PI)

    const positions = this.geometry.attributes.position.array
    const uvs = new Float32Array(positions.length / 3 * 2) // 创建新的 UV 数组

    // 重新计算 UV 坐标
    for (let i = 0; i < positions.length / 3; i++) {
      const x = positions[i * 3]
      const z = positions[i * 3 + 2]

      const u = (x * 0.8 + 1) / 2 // 将 x 坐标映射到 [0, 1]
      const v = (z * 0.8 + 1) / 2 // 将 z 坐标映射到 [0, 1]

      uvs[i * 2] = u
      uvs[i * 2 + 1] = v
    }

    // 将新的 UV 坐标添加到几何体
    this.geometry.setAttribute('uv', new BufferAttribute(uvs, 2))

    this.material = new ShaderMaterial({
      uniforms: this.uniforms,
      vertexShader: skyShader.vertexShader,
      fragmentShader: skyShader.fragmentShader,
      side: 2,
      transparent: true,
      depthWrite: false,
      toneMapped: false, // 添加这行
    })

    // this.position.y = -500
    // this.scale.set(19990, 8000, 19990)
    this.renderOrder = -1
  }

  setTime(time: number) {
    this.uniforms.skyTime = { value: time.toFixed(1) }
  }
}

export default OutlineMesh